module.exports = __webpack_public_path__ + "static/media/Pordenone.cb312580.png";